// Okabe–Ito colorblind-safe palette, adapted to the paper background.
// Each step color ships three tokens:
//   deep — dark enough for text/numbers, ≥4.5:1 on the paper tone (WCAG AA)
//   base — the accent itself (borders, rails, fills behind deep text)
//   tint — a light wash for backgrounds behind ink-colored text
// Color is never the only signal: every colored element also carries the step number.

export type StepColor = {
  name: string;
  deep: string;
  base: string;
  tint: string;
};

export const STEP_COLORS: StepColor[] = [
  { name: 'orange', deep: '#7A5100', base: '#E69F00', tint: '#F7E8C8' },
  { name: 'sky', deep: '#14618F', base: '#56B4E9', tint: '#DEEFFA' },
  { name: 'green', deep: '#00664B', base: '#009E73', tint: '#D5F0E5' },
  { name: 'olive', deep: '#6A6000', base: '#D6C822', tint: '#F6F1C6' },
  { name: 'blue', deep: '#005380', base: '#0072B2', tint: '#DCEBF6' },
  { name: 'vermillion', deep: '#963E00', base: '#D55E00', tint: '#F9E2D2' },
  { name: 'plum', deep: '#8E4067', base: '#CC79A7', tint: '#F5E3EC' },
  { name: 'charcoal', deep: '#3D3833', base: '#8A7F73', tint: '#EAE4DB' },
];

export function stepColor(n: number): StepColor {
  return STEP_COLORS[(n - 1) % STEP_COLORS.length];
}
